/**
 * The external dependencies.
 */
import {combineReducers} from 'redux';
import {handleActions} from 'redux-actions';
import {assoc} from 'ramda';
/**
 * The internal dependencies.
 */
import {endRequest, endRequestWithError, resetRequests, startRequest} from './actions';

/**
 * Track the status of all network requests across the application.
 *
 * @type   {Function}
 * @return {Object}
 */
export const items = handleActions({
    [startRequest]: (state, {payload: {id}}) => assoc(id, {
        running: true,
        error: '',
        success: ''
    }, state),
    [endRequest]: (state, {payload: {id, successMessage = ''}}) => assoc(id, {
        running: false,
        error: '',
        success: successMessage
    }, state),
    [endRequestWithError]: (state, {payload: {id, error}}) => assoc(id, {
        running: false,
        error,
        success: ''
    }, state),
    [resetRequests]: (state, {payload}) => ({}),
}, {});

export default combineReducers({
    items
});



// WEBPACK FOOTER //
// ./src/store/requests/reducer.js